import React, { useState } from 'react';
import { QuickQuoteContext } from './QuickQuoteContext';

const QuickQuoteProvider = ({ children }) => {
  const [toggle, setToggle] = useState(false);
  const [vehicleData, setVehicleData] = useState(null);

  const handleOpenQuote = () => {
    setToggle(true);
  };

  const handleClose = () => {
    setToggle(false);
  };

  return (
    <QuickQuoteContext.Provider
      value={{
        toggle,
        handleOpenQuote,
        handleClose,
        vehicleData,
        setVehicleData,
      }}
    >
      {children}
    </QuickQuoteContext.Provider>
  );
};

export default QuickQuoteProvider;
